import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {
    GameSessionPromotionEvents,
    GameSessionPromotionModule,
    GameSessionPromotionStates
} from '@gongxigames/framework/promotions';

export class GameSessionPromotionRestoreState extends ModuleState<null, GameSessionPromotionModule, GameSessionPromotionEvents> {
    public onEnterState(): void {
        this.emit('General.Flow.WAIT_EVENT_BEFORE_RESTORE_GAME', 'GameSessionPromotion.START_STATE_LEFT');
    }

    protected setupEvents(): void {
        this.setEventHandler('General.Flow.WAITING_OF_RESTORE_GAME', this.onRestoreGame.bind(this));
    }

    private onRestoreGame(): void {
        this.module.gotoState(GameSessionPromotionStates.START);
    }

    public onLeaveState(): void {}
}
